__turbopack_context__.v({
  "icon": "ZDXuKq_icon",
  "input": "ZDXuKq_input",
  "searchBar": "ZDXuKq_searchBar",
  "shortcut": "ZDXuKq_shortcut",
});
